import {Button, openDialog} from 'platform/components';
import {Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {SendCustomerSmsForm, useKonzultaSmsAvailability} from '@dms/shared';

interface CustomerInsightsPhoneActionProps {
  customerId: string;
  value: string;
}

export function CustomerInsightsPhoneAction(props: CustomerInsightsPhoneActionProps) {
  const {isSmsActionDisabled} = useKonzultaSmsAvailability();

  return match(isSmsActionDisabled)
    .with(true, () => (
      <Text size="small" color="primary" overflowWrap="anywhere">
        {props.value}
      </Text>
    ))
    .with(false, () => (
      <Button
        type="button"
        size="small"
        variant="link"
        title={props.value}
        onClick={() =>
          openDialog(
            <SendCustomerSmsForm
              customerId={props.customerId}
              recordId={props.customerId}
              resourceId={EntityResourceIds.customer}
            />,
            {
              scrollBehavior: 'outside',
              size: 'large',
              title: i18n.t('general.labels.smsMessage'),
            }
          )
        }
      />
    ))
    .exhaustive();
}
